import * as React from 'react';

import { cn } from '#app/utils/misc.tsx';

export interface InputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type = 'text', ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'peer block h-10 w-full border border-input border-b-0 border-neutral-300 bg-transparent px-6 pb-4 pt-12 text-base/6 ring-4 ring-transparent transition file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus:border-neutral-950 focus:outline-none focus:ring-neutral-950/5 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 group-first:rounded-t-2xl group-last:rounded-b-2xl aria-[invalid]:border-input-invalid aria-[invalid]:border-b-[1px] focus:border-b-[1px]',
					className,
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Input.displayName = 'Input';

export { Input };
